import {
    PRODUCT_APPROVAL,
    DATATABLE_EXPORT,
} from "../../../../Config/ApiUrl";

export const Schema = {
    data() {
        return {
            DATATABLE_EXPORT,
            selectedUrl: PRODUCT_APPROVAL,
            Endpoint: PRODUCT_APPROVAL,
            showPDF: false,
            pdfUrl: '',
            selectedApprovalUrl: '',
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            tableId: "product-approval-table",
            formId: "product-approval-table-form",
            formIdApproval: "product-approval-form-approval",
			confirmAction: null,
            confirmInvoiceId: 0,
            confirmApprovalStatusId: 0,
            confirmModalApproval: false,
            modalApprovalTitle: '',
            rowData: {},
            tableColumns: [
                {
                    title: "CLC ID Number",
                    type: "custom-html",
                    key: "lead",
                    modifier: (value) => {
                        return value?.student_id || value?.lead_id_number || value?.clc_id_number || "-";
                    }
                },
                {
                    title: "Student Name",
                    type: "custom-html",
                    key: "lead",
                    modifier: (value) => {
                        return value?.full_name;
                    }
                },
                {
                    title: "Request By",
                    type: "custom-html",
                    key: "request_user_id",
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            return value.full_name
                        } else {
                            return ""
                        }
                    }
                },
                {
                    title: "Invoice Request ID",
                    type: "text",
                    key: "request_no",
                },
                {
                    title: "Semester",
                    type: "custom-html",
                    key: "academic_calendar",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.academic_calendar_name : '-'
                    },
                },
                {
                    title: "Product",
                    type: "custom-html",
                    key: "product",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.name : '-';
                    },
                },
                {
                    title: "Packages",
                    type: "custom-html",
                    key: "packages",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.package_name : '-';
                    },
                },
                {
                    title: "Course",
                    type: "custom-html",
                    key: "course",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.course_name : '-';
                    },
                },
                {
                    title: "Student Care",
                    type: "custom-html",
                    key: "approval_statuses",
                    modifier: (approvalStatus, rowData) => {
                        if (approvalStatus && approvalStatus.length > 0) {
                            let role = "SC";
                            let ClassName = "danger";
                            let label = "Waiting";
                            let needApproval = false;

                            for (let status of approvalStatus) {
                                let invStatus = status.invoice_status;
                                if (invStatus.endsWith(role)) {
                                    invStatus = invStatus.toLowerCase();
                                    if (invStatus.startsWith('waiting')) {
                                        ClassName = `primary`;
                                        label = "Waiting for approval";
                                        needApproval = true;
                                    }
                                    else if (invStatus.includes('approved')) {
                                        ClassName = `success`;
                                        label = "Approved";
                                    }
                                    else if (invStatus.includes('rejected')) {
                                        ClassName = `danger`;
                                        label = "Rejected";
                                    }
                                    if (status.approval_at) {
                                        let approvalAt = '' + status.approval_at;
                                        approvalAt = approvalAt.split(' ')[0];
                                        label += ` at ${approvalAt}`;
                                    }
                                    let statusHtml = `<div class="text-center"><span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(label)}</span>`;
                                    if (status.note) {
                                        statusHtml += `<br>${status.note}`;
                                    }
                                    if (needApproval) {
                                        statusHtml += `
                                            <div style="margin-top: 5px;">
                                                <button class="btn btn-success btn-sm" title="Approve"  onclick="window.__approveInvoiceStatus('${rowData.id}', '${status.id}')"><i class="fa fa-check"></i></button>
                                                <button class="btn btn-danger btn-sm" title="Reject"  onclick="window.__rejectInvoiceStatus('${rowData.id}', '${status.id}')"><i class="fa fa-times"></i></button>
                                            </div>
                                            `;
                                    }
                                    statusHtml += `</div>`;
                                    return statusHtml;
                                }
                            }
                        }
                        return '';
                    }
                },
                {
                    title: "Academic Advisor",
                    type: "custom-html",
                    key: "approval_statuses",
                    modifier: (approvalStatus, rowData) => {
                        if (approvalStatus && approvalStatus.length > 0) {
                            let role = "AC";
                            let ClassName = "danger";
                            let label = "Waiting";
                            let needApproval = false;

                            for (let status of approvalStatus) {
                                let invStatus = status.invoice_status;
                                if (invStatus.endsWith(role)) {
                                    invStatus = invStatus.toLowerCase();
                                    if (invStatus.startsWith('waiting')) {
                                        ClassName = `primary`;
                                        label = "Waiting for approval";
                                        needApproval = true;
                                    }
                                    else if (invStatus.includes('approved')) {
                                        ClassName = `success`;
                                        label = "Approved";
                                    }
                                    else if (invStatus.includes('rejected')) {
                                        ClassName = `danger`;
                                        label = "Rejected";
                                    }
                                    if (status.approval_at) {
                                        let approvalAt = '' + status.approval_at;
                                        approvalAt = approvalAt.split(' ')[0];
                                        label += ` at ${approvalAt}`;
                                    }
                                    let statusHtml = `<div class="text-center"><span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(label)}</span>`;
                                    if (status.note) {
                                        statusHtml += `<br>${status.note}`;
                                    }
                                    if (needApproval) {
                                        statusHtml += `
                                            <div style="margin-top: 5px;">
                                                <button class="btn btn-success btn-sm" title="Approve"  onclick="window.__approveInvoiceStatus('${rowData.id}', '${status.id}')"><i class="fa fa-check"></i></button>
                                                <button class="btn btn-danger btn-sm" title="Reject"  onclick="window.__rejectInvoiceStatus('${rowData.id}', '${status.id}')"><i class="fa fa-times"></i></button>
                                            </div>
                                            `;
                                    }
                                    statusHtml += `</div>`;
                                    return statusHtml;
                                }
                            }
                        }
                        return '';
                    }
                },
                {
                    title: "Supervisor Teacher",
                    type: "custom-html",
                    key: "approval_statuses",
                    modifier: (approvalStatus, rowData) => {
                        if (approvalStatus && approvalStatus.length > 0) {
                            let role = "ST";
                            let ClassName = "danger";
                            let label = "Waiting";
                            let needApproval = false;

                            for (let status of approvalStatus) {
                                let invStatus = status.invoice_status;
                                if (invStatus.endsWith(role)) {
                                    invStatus = invStatus.toLowerCase();
                                    if (invStatus.startsWith('waiting')) {
                                        ClassName = `primary`;
                                        label = "Waiting for approval";
                                        needApproval = true;
                                    }
                                    else if (invStatus.includes('approved')) {
                                        ClassName = `success`;
                                        label = "Approved";
                                    }
                                    else if (invStatus.includes('rejected')) {
                                        ClassName = `danger`;
                                        label = "Rejected";
                                    }
                                    if (status.approval_at) {
                                        let approvalAt = '' + status.approval_at;
                                        approvalAt = approvalAt.split(' ')[0];
                                        label += ` at ${approvalAt}`;
                                    }
                                    let statusHtml = `<div class="text-center"><span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(label)}</span>`;
                                    if (status.note) {
                                        statusHtml += `<br>${status.note}`;
                                    }
                                    if (needApproval) {
                                        statusHtml += `
                                            <div style="margin-top: 5px;">
                                                <button class="btn btn-success btn-sm" title="Approve"  onclick="window.__approveInvoiceStatus('${rowData.id}', '${status.id}')"><i class="fa fa-check"></i></button>
                                                <button class="btn btn-danger btn-sm" title="Reject"  onclick="window.__rejectInvoiceStatus('${rowData.id}', '${status.id}')"><i class="fa fa-times"></i></button>
                                            </div>
                                            `;
                                    }
                                    statusHtml += `</div>`;
                                    return statusHtml;
                                }
                            }
                        }
                        return '';
                    }
                },
                {
                    title: "Finance",
                    type: "custom-html",
                    key: "approval_statuses",
                    modifier: (approvalStatus, rowData) => {
                        if (approvalStatus && approvalStatus.length > 0) {
                            let role = "Finance";
                            let ClassName = "danger";
                            let label = "Waiting";
                            let needApproval = false;

                            for (let status of approvalStatus) {
                                let invStatus = '' + status.invoice_status;
                                if (invStatus.endsWith(role)) {
                                    invStatus = invStatus.toLowerCase();
                                    if (invStatus.startsWith('waiting')) {
                                        ClassName = `primary`;
                                        label = "Waiting for approval";
                                        needApproval = true;
                                    }
                                    else if (invStatus.includes('approved')) {
                                        ClassName = `success`;
                                        label = "Approved";
                                    }
                                    else if (invStatus.includes('rejected')) {
                                        ClassName = `danger`;
                                        label = "Rejected";
                                    }
                                    if (status.approval_at) {
                                        let approvalAt = '' + status.approval_at;
                                        approvalAt = approvalAt.split(' ')[0];
                                        label += ` at ${approvalAt}`;
                                    }
                                    let statusHtml = `<div class="text-center"><span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(label)}</span>`;
                                    if (status.note) {
                                        statusHtml += `<br>${status.note}`;
                                    }
                                    if (needApproval) {
                                        statusHtml += `
                                            <div style="margin-top: 5px;">
                                                <button class="btn btn-success btn-sm" title="Approve" onclick="window.__approveInvoiceStatus('${rowData.id}', '${status.id}')"><i class="fa fa-check"></i></button>
                                                <button class="btn btn-danger btn-sm" title="Reject" onclick="window.__rejectInvoiceStatus('${rowData.id}', '${status.id}')"><i class="fa fa-times"></i></button>
                                            </div>
                                            `;
                                    }
                                    statusHtml += `</div>`;
                                    return statusHtml;
                                }
                            }
                        }
                        return '';
                    }
                },
                {
                    title: "Request Date",
                    type: "text",
                    key: "request_date",
                },
                // {
                //     title: "Completed By",
                //     type: "text",
                //     key: "completed_user_id",
                // },
                {
                    title: "Action",
                    type: "action",
                },
                // {
                //     title: "Fees Notice ID",
                //     type: "text",
                //     key: "invoice_no",
                // },
                // {
                //     title: "Print Date",
                //     type: "text",
                //     key: "request_print_date",
                // },
                // {
                //     title: "Due Date",
                //     type: "text",
                //     key: "due_date",
                // },
            ],
            actionObj: {
                title: this.$t("action"),
                type: "action2",
            },
            options: {
                name: "ProductApprovalHistoryTable",
                url: PRODUCT_APPROVAL,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    // {
                    //     title: this.$t("edit"),
                    //     icon: "edit",
                    //     type: "page",
                    //     url: (rowData) => `transaction/profile-student/invoice/invoice-request-v2/${rowData.id}`,
                    //     target: "", // _blank to open newtab
                    //     uniqueKey: (rowData) => rowData.id,
                    //     disabled: (rowData) => {
                    //         return !rowData.lead || this.isButtonDisabled(rowData);
                    //     }
                    // },
                    {
                        title: 'View',
                        icon: "eye",
                        type: "page",
                        disabled: (rowData) => this.isButtonDisabled(rowData)
                    },
                    // {
                    //     title: 'Print',
                    //     icon: "file",
                    //     type: "page",
                    //     disabled: (rowData) => this.isButtonDisabled(rowData)
                    // },
                ],
                // actions2: [
                //     {
                //         title: this.$t("delete"),
                //         icon: "trash",
                //         type: "none",
                //         component: "app-confirmation-modal",
                //         modalId: "demo-delete",
                //         disabled: (rowData) => this.isButtonDisabled(rowData)
                //     },
                // ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
                // afterRequestSuccess: (res) => {
                //     console.log(res);
                // },
            },
        };
    },
    methods: {
        isButtonDisabled(rowData) {
            return rowData.status?.toLowerCase() === "deleted" || (rowData.deduction_type?.toLowerCase() === 'voucher');
        },
    },
};
